var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.121 60.0058C45.5983 73.5285 23.6736 73.5285 10.1508 60.0058C-3.3719 46.483 -3.3719 24.5583 10.1508 11.0356C23.6736 -2.48713 45.5983 -2.48713 59.121 11.0356C72.6438 24.5583 72.6438 46.483 59.121 60.0058Z",
    fill: "#4B5158"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5441_7032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6756 43.2912C18.9403 43.0265 19.3042 42.8721 19.6902 42.8721H54.6952C55.3349 42.8721 55.6547 43.6441 55.2025 44.0963L48.2876 51.0113C48.0229 51.276 47.6589 51.4304 47.2729 51.4304H12.2679C11.6283 51.4304 11.3084 50.6583 11.7606 50.2062L18.6756 43.2912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6717 17.4728C18.9474 17.2081 19.3113 17.0537 19.6863 17.0537H54.6913C55.331 17.0537 55.6508 17.8257 55.1986 18.2779L48.2837 25.1929C48.019 25.4576 47.655 25.612 47.269 25.612H12.264C11.6243 25.612 11.3045 24.84 11.7567 24.3878L18.6717 17.4728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2876 30.2991C48.0229 30.0344 47.6589 29.88 47.2729 29.88H12.2679C11.6283 29.88 11.3084 30.652 11.7606 31.1042L18.6756 38.0192C18.9403 38.2838 19.3042 38.4382 19.6902 38.4382H54.6952C55.3349 38.4382 55.6547 37.6662 55.2025 37.2141L48.2876 30.2991Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5441_7032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.861,
    height: 34.3764,
    fill: "white",
    transform: "translate(11.5508 17.0537)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.015899f4d5d0857a985e570ca05af964.svg";
export { ForwardRef as ReactComponent };